/* eslint-disable prettier/prettier */
import { MyThunkResult } from 'store';

import { AccessLogResponse } from 'models/accessLog';

import { doLoadHasAccess, accessRequest } from '../action-creators/accessLog';
import { profile, axiosConfig } from '../api';

export const fetchHasAccess =
  (screen: string): MyThunkResult<Promise<void>> =>
  async (dispatch) => {
    dispatch(accessRequest());
    const response = await profile.get<AccessLogResponse>(`AccessLog/GetAccessLog/${screen}`, axiosConfig);
    const { data } = response.data;
    const newData = {
      hasAccess: data.hasAccess,
      screenName: screen,
    };
    dispatch(doLoadHasAccess(newData));
  };
